import {
    DOWNLOAD_TEMPLATE,
    DOWNLOAD_TEMPLATE_SUCCESS,
    DOWNLOAD_TEMPLATE_FAILED,

    UPLOAD,
    UPLOAD_SUCCESS,
    UPLOAD_FAILED,
} from './constants';

type Action = { type: string, payload: {} | string };

export const downloadTemplate = (apiPath: str): Action => ({
    type: DOWNLOAD_TEMPLATE,
    payload: {apiPath},
});

export const downloadTemplateSuccess = (): Action => ({
    type: DOWNLOAD_TEMPLATE_SUCCESS,
    payload: {},
});

export const downloadTemplateFailed = (error: string): Action => ({
    type: DOWNLOAD_TEMPLATE_FAILED,
    payload: error,
});

export const upload = (apiPath, file): Action => ({
    type: UPLOAD,
    payload: {apiPath, file},
});

export const uploadSuccess = (): Action => ({
    type: UPLOAD_SUCCESS,
    payload: {},
});

export const uploadFailed = (error: string): Action => ({
    type: UPLOAD_FAILED,
    payload: error,
});